"use client";
import React, { useRef,useEffect } from "react";
import "../styles/Aboutpr.css";
import { Heropar } from "../components/Heropar";
import Beams from "./Beams"; 

import img1 from "../assets/electric2A.jpg";
import img2 from "../assets/oil&gas5A.jpg";
import img3 from "../assets/transformer1A.webp";
import img4 from "../assets/aboutus1.jpeg";
import img5 from "../assets/aboutus2.jpeg";
import img6 from "../assets/oil&gas6A.jpg";
import img7 from "../assets/solar1A.avif";
import img8 from "../assets/transformer2A.jpg";

const products = [
  { thumbnail: img1 },
  { thumbnail: img2 },
  { thumbnail: img3 },
  { thumbnail: img4 },
  { thumbnail: img5 },
  { thumbnail: img6 },
  { thumbnail: img7 },
  { thumbnail: img8 },
];

const Aboutpr = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  const form = useRef();
  return (
    <div className="aboutpr-container">
      <div className="silk-bg">
         <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
      </div>
     <Heropar
  products={products}
  heading="About Us"
  description="  Learn more about our vision, mission, team, and the services we offer
        to drive innovation and excellence."
/>

    </div>
  );
};

export default Aboutpr;
